var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3614 35.2858C35.1106 31.4019 37.0977 29.9907 36.356 22.6576C35.6176 15.3381 30.3992 12.1373 25.0566 12.126C19.7151 12.1373 14.4956 15.3381 13.7561 22.6576C13.0166 29.9907 15.0026 31.4019 10.7506 35.2858C8.99837 36.8857 10.1161 38.0621 11.3863 38.0621H25.0566H38.7269C39.9982 38.0621 41.1137 36.8857 39.3614 35.2858Z",
    stroke: "#231D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.593 12.3659C22.593 10.4217 23.6961 8.84668 25.0577 8.84668C26.4182 8.84668 27.5201 10.4217 27.5201 12.3659",
    stroke: "#231D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2431 38.0615C29.2431 40.3444 27.3678 42.196 25.0556 42.196C22.7456 42.196 20.8702 40.3444 20.8702 38.0615",
    stroke: "#231D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5173 10.4365C38.175 10.4365 40.3304 12.5727 40.3304 15.2067C40.3304 17.8407 38.175 19.9757 35.5173 19.9757C32.8595 19.9757 30.7042 17.8407 30.7042 15.2067C30.7042 12.5727 32.8595 10.4365 35.5173 10.4365Z",
    fill: "#F25C54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/Bell Icon.11d1c344c27edf6bc3889d996f1192a8.svg";
export { ForwardRef as ReactComponent };